import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from 'services/useAuth';
import { Spin } from 'antd';

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated, initialized, validating } = useIsAuthenticated();

  if (!initialized || validating) {
    return <Spin fullscreen />;
  }

  if (!isAuthenticated) {
    // Store the current location to redirect back after login
    // const redirect = window.location.pathname + window.location.search;
    // localStorage.setItem('redirect_path', redirect);
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
